export default __webpack_public_path__ + "static/media/IMG_20190720_200742.54e0924e.jpg";